import { ILinks, IPaginatedResponse, IRequestMeta } from '../../../typing/response.interface';

export class CommonTableData<T> {
    constructor(data?: IPaginatedResponse<T>) {
        this._data = data?.data || [];
        this._meta = data?.meta;
        this._links = data?.links || null;
    }

    private _data: T[];

    get data(): T[] {
        return this._data;
    }

    set data(value) {
        this._data = value;
    }

    private _meta: IRequestMeta | undefined;

    get meta(): IRequestMeta | undefined {
        return this._meta;
    }

    set meta(value: IRequestMeta) {
        this._meta = value;
    }

    private _links: ILinks | null;

    get links(): ILinks | null {
        return this._links;
    }

    add(item: T): T[] {
        this._data.push(item);
        return this._data;
    }
}
